import { render, staticRenderFns } from "./oldLogin.vue?vue&type=template&id=5584f8da&scoped=true&"
import script from "./oldLogin.vue?vue&type=script&lang=js&"
export * from "./oldLogin.vue?vue&type=script&lang=js&"
import style0 from "./oldLogin.vue?vue&type=style&index=0&id=5584f8da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5584f8da",
  null
  
)

export default component.exports